// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2YWlm","footer":"ModalInfo_footer__e-Rhk"};